import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { MarketdateMeterreadingPopupService } from './marketdate-meterreading-popup.service';
import { MarketdateMeterreadingService } from './marketdate-meterreading.service';
import { Marketdate, MarketdateService } from '../marketdate';
import { User, UserService } from '../../shared';
import { Electricmeter, ElectricmeterService } from '../electricmeter';

@Component({
    selector: 'jhi-marketdate-meterreading-dialog',
    templateUrl: './marketdate-meterreading-dialog.component.html'
})
export class MarketdateMeterreadingDialogComponent implements OnInit {

    marketdateMeterreading: MarketdateMeterreading;
    authorities: any[];
    isSaving: boolean;

    marketdates: Marketdate[];

    users: User[];

    electricmeters: Electricmeter[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdateMeterreadingService: MarketdateMeterreadingService,
        private marketdateService: MarketdateService,
        private userService: UserService,
        private electricmeterService: ElectricmeterService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(
            (res: Response) => { this.marketdates = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
        this.electricmeterService.query().subscribe(
            (res: Response) => { this.electricmeters = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdateMeterreading.id !== undefined) {
            this.marketdateMeterreadingService.update(this.marketdateMeterreading)
                .subscribe((res: MarketdateMeterreading) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateMeterreadingService.create(this.marketdateMeterreading)
                .subscribe((res: MarketdateMeterreading) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: MarketdateMeterreading) {
        this.eventManager.broadcast({ name: 'marketdateMeterreadingListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdateById(index: number, item: Marketdate) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }

    trackElectricmeterById(index: number, item: Electricmeter) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-meterreading-popup',
    template: ''
})
export class MarketdateMeterreadingPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateMeterreadingPopupService: MarketdateMeterreadingPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdateMeterreadingPopupService
                    .open(MarketdateMeterreadingDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdateMeterreadingPopupService
                    .open(MarketdateMeterreadingDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading-dialog.component.ts